import repository from '../Repository';

  const brokerEndpoint = (brokerType) => ['broker', brokerType].join("/");

  const getBrokerList = (brokerType) => repository.private().get(`${brokerEndpoint(brokerType)}`);
  const getBrokersAvailableToUser = (userId) => repository.private().get(`broker/available-to?user_id=${userId}`);
  const createBroker = (brokerType, body) => repository.private().post(`${brokerEndpoint(brokerType)}/`, body);
  const swapAssignedExecutives = (idBroker, body) => repository.private().patch(`broker/admin/${idBroker}/swap-executives/`, body);
  export {
    getBrokerList,
    createBroker,
    getBrokersAvailableToUser,
    swapAssignedExecutives,
  }